import { Box, Flex, Image, Tag, Text } from '@chakra-ui/react';
import { GlobalSearchProductApprovalItem } from '@texas/api/endpoints/search/searchApi';
import { AngularNavLink } from '@texas/components/shared/AngularNavLink';
import { clientEndpoints } from '@texas/clientEndpoints';
import { ExpandImage } from '../shared/image/ExpandImage';
import placeholderImg from '@texas/assets/placeholder-50.png';
import { useTranslation } from 'react-i18next';

interface Props {
  productApproval: GlobalSearchProductApprovalItem;
  onResultClick: () => void;
}

export function ProductApprovalItem({ productApproval, onResultClick }: Props) {
  const { t } = useTranslation();
  return (
    <AngularNavLink
      to="article.productApproval"
      navobj={{
        articleId: productApproval.articleId,
        searchTerm: productApproval.productApprovalNumber,
        state: productApproval.productApprovalState,
      }}
      onClick={onResultClick}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={2}
      borderRadius="md"
      _hover={{
        bg: 'whiteAlpha.100',
        _light: { bg: 'blackAlpha.100' },
      }}
      textDecoration="none"
    >
      <Flex alignItems="center" gap={3}>
        <ExpandImage
          identifier={productApproval.imageIdentifier}
          variant="scale"
        >
          <Image
            boxSize="12"
            src={
              productApproval.imageIdentifier
                ? clientEndpoints.previewImage(
                    productApproval.imageIdentifier,
                    128,
                  )
                : undefined
            }
            fallbackSrc={placeholderImg}
            objectFit="contain"
            borderRadius="md"
          />
        </ExpandImage>
        <Box>
          <Text fontWeight="bold">{productApproval.productApprovalNumber}</Text>
          <Text fontSize="sm">{productApproval.articleItemCode}</Text>
        </Box>
      </Flex>
      <Flex gap={2} align="center" flexShrink={0}>
        <Tag size="sm" colorScheme="gray">
          {productApproval.productApprovalState}
        </Tag>
        {productApproval.isMatrix && (
          <Tag size="sm" colorScheme="purple">
            {t('general.matrix')}
          </Tag>
        )}
        {productApproval.isVariable && (
          <Tag size="sm" colorScheme="teal">
            {t('general.variable')}
          </Tag>
        )}
      </Flex>
    </AngularNavLink>
  );
}
